import { render, staticRenderFns } from "./EDS.vue?vue&type=template&id=f19f0c26&scoped=true"
import script from "./EDS.vue?vue&type=script&lang=js"
export * from "./EDS.vue?vue&type=script&lang=js"
import style0 from "./EDS.vue?vue&type=style&index=0&id=f19f0c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f0c26",
  null
  
)

export default component.exports